/**
 * @fileoverview Estilos comuns aos controles das seções de configurações:
 * campos com a cara do select padrão (modernFieldStyles), mensagem de erro e o
 * botão secundário neutro.
 */

import { makeStyles } from "@material-ui/core/styles";

import { modernFieldStyles } from "../../../components/ModernSelect";
import { tokens } from "../../../components/Triage/styles";

const useSectionStyles = makeStyles((theme) => {
  const c = tokens(theme.palette.type === "dark");
  const xs = theme.breakpoints.down("xs");
  return {
    field: { ...modernFieldStyles(theme), width: "100%" },
    numberField: {
      ...modernFieldStyles(theme),
      width: 128,
      [xs]: { width: "100%" },
    },
    inline: {
      display: "flex",
      alignItems: "flex-start",
      gap: 8,
      [xs]: { width: "100%" },
    },
    unitSelect: { minWidth: 132, [xs]: { minWidth: 0, flex: 1 } },
    error: { margin: "6px 0 0", fontSize: 12, color: c.danger, lineHeight: 1.5 },
    secondaryButton: {
      height: 36,
      padding: "0 14px",
      borderRadius: 8,
      border: `1px solid ${c.inputBorder}`,
      background: "transparent",
      color: c.textPrimary,
      fontSize: 13,
      fontWeight: 500,
      fontFamily: "inherit",
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      cursor: "pointer",
      whiteSpace: "nowrap",
      transition: "background 120ms",
      "&:hover:not(:disabled)": { background: c.hover },
      "&:disabled": { opacity: 0.6, cursor: "default" },
      "&:focus-visible": { outline: "none", boxShadow: `0 0 0 2px ${c.inputBorder}` },
    },
  };
});

export default useSectionStyles;
